import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type CsticUpdate } from "~/features/configurator/Linear/api/sendLinearConfiguratorUpdate";
import { sendRail } from "~/features/configurator/Rail/api/sendRailCommon";
import { buildConfiguratorMutationCommand } from "~/features/configurator/common/api/configuratorCommands";

export function sendRailUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration | null> {
  const result = buildConfiguratorMutationCommand(linearState, updatedCstics);
  return result.kind === "local-only" ? Promise.resolve(null) : sendRail(result.command);
}
